import { ProductLockup } from "@/components/ui/ProductLockup";
import { PRODUCTS } from "@/content/quikit";
import { PRODUCT_PAGES } from "@/lib/product-pages";

/**
 * A product's mark and name, for the top of its own page's hero.
 *
 * Takes the catalogue key and derives the rest, so a hero never has to repeat a name the
 * catalogue owns: the artwork is looked up by the page's URL slug (QuikSlides lives at
 * /slides but is keyed `presentation`) and the name comes straight from PRODUCTS.
 */
export function ProductMark({ productKey, className }: { productKey: string; className?: string }) {
  const product = PRODUCTS.find((p) => p.key === productKey);
  const slug = PRODUCT_PAGES[productKey]?.split("/").pop();
  if (!product || !slug) return null;

  return <ProductLockup slug={slug} name={product.name} dark className={className} />;
}
